// MEMBERS · LISTA DE DESEOS.
//
// ⚠️ EL NAVEGADOR MANDA EN LO QUE SE PINTA; LA CUENTA ES LA COPIA DURADERA. Justo al revés que los
// puntos. El motivo es que el corazón tiene que responder AL INSTANTE y funcionar SIN haber iniciado
// sesión: si la pantalla esperase al servidor, cada corazón daría un parpadeo, y quien no tiene
// cuenta no podría guardar nada. Así que:
//
//   1. Al pulsar se escribe en el propio navegador y se pinta. Sin red de por medio.
//   2. Si hay socio, se le cuenta al servidor DESPUÉS. Si falla, el deseo sigue guardado aquí y se
//      subirá en la siguiente fusión. No se pierde por una mala cobertura.
//   3. Al entrar con la cuenta se FUNDEN las dos listas, y fundir NUNCA borra (regla del servidor).
//
// ⚠️ NO CADUCA NADA Y NO SE BORRA NADA SOLO. Un deseo desaparece únicamente cuando su dueño lo quita.
(function () {
  var CLAVE = 'casdeia:wishlist';
  var cfg = window.CASDEIA_WISHLIST || {};
  var endpoint = cfg.endpoint || 'https://returns.casdeia.com/exec';
  // Hay socio solo si vienen LAS DOS cosas. El pase sin identificador no abre nada, y al revés
  // tampoco: el servidor comprueba que cuadren.
  var haySocio = !!(cfg.cliente && cfg.pase);

  // ── el almacén del navegador ────────────────────────────────────────────────────────────────
  // Todo lo que toca localStorage va protegido: en navegación privada de algunos navegadores, o con
  // el almacenamiento lleno, escribir LANZA. Una lista de deseos rota no puede tumbar la ficha de
  // producto entera, así que si no se puede guardar, simplemente no se guarda.
  function leer() {
    try {
      var v = JSON.parse(localStorage.getItem(CLAVE) || '[]');
      return Array.isArray(v) ? v.filter(function (i) { return i && i.h; }) : [];
    } catch (e) { return []; }
  }
  function escribir(lista) {
    try { localStorage.setItem(CLAVE, JSON.stringify(lista.slice(0, 200))); } catch (e) { /* da igual */ }
    avisar(lista);
  }
  function avisar(lista) {
    try {
      document.dispatchEvent(new CustomEvent('casdeia:wishlist', { detail: { items: lista } }));
    } catch (e) { /* navegador antiguo */ }
  }

  function tiene(handle) {
    return leer().some(function (i) { return i.h === handle; });
  }

  // ── hablar con el servidor ──────────────────────────────────────────────────────────────────
  // Siempre en segundo plano y siempre en silencio: NADA de lo que pase aquí puede cambiar lo que el
  // socio ve. Ya lo tiene guardado en su navegador.
  function pedir(action, extra) {
    if (!haySocio) return Promise.resolve(null);
    var cuerpo = { action: action, cliente: cfg.cliente, pase: cfg.pase };
    for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) cuerpo[k] = extra[k];
    // text/plain a propósito: petición "simple", sin comprobación previa del navegador.
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  // ── poner y quitar ──────────────────────────────────────────────────────────────────────────
  function guardar(handle, variantId) {
    var lista = leer();
    if (!lista.some(function (i) { return i.h === handle; })) {
      lista.unshift({ h: handle, v: variantId || '' });
      escribir(lista);
    }
    pedir('members-wishlist-guardar', { producto: handle, talla: variantId || '' });
  }
  function quitar(handle) {
    escribir(leer().filter(function (i) { return i.h !== handle; }));
    pedir('members-wishlist-quitar', { producto: handle });
  }

  // ── el corazón ──────────────────────────────────────────────────────────────────────────────
  function pintarBoton(btn) {
    var dentro = tiene(btn.getAttribute('data-wishlist'));
    btn.classList.toggle('esta-guardado', dentro);
    btn.setAttribute('aria-pressed', dentro ? 'true' : 'false');
    var txt = btn.querySelector('[data-wishlist-texto]');
    if (txt) txt.textContent = dentro ? (btn.getAttribute('data-texto-si') || '') : (btn.getAttribute('data-texto-no') || '');
  }
  function pintarTodos() {
    document.querySelectorAll('[data-wishlist]').forEach(pintarBoton);
    // El corazón de la cabecera se rellena si hay algo guardado. Es la única señal de que la lista
    // existe para quien no ha entrado nunca en el panel.
    var cab = document.querySelector('.header-deseos-link');
    var cuantas = leer().length;
    if (cab) {
      cab.classList.toggle('tiene-deseos', cuantas > 0);
      // La chapita del corazón, igual que la del carrito. El corazón ya no cambia de relleno para
      // decir que tienes piezas (era el único icono de contorno de la cabecera y desentonaba con sus
      // vecinos): ahora lo dice el número. Vacía se esconde sola por CSS.
      var chapa = cab.querySelector('[data-wishlist-chapa]');
      if (chapa) chapa.textContent = cuantas > 0 ? String(cuantas) : '';
    }
  }

  // Por delegación: el tema rehace trozos de la ficha al cambiar de talla, y un listener pegado al
  // botón se perdería en ese momento (la misma trampa que la barra de filtros de las colecciones).
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-wishlist]');
    if (!btn) return;
    ev.preventDefault();
    var handle = btn.getAttribute('data-wishlist');
    if (!handle) return;
    if (tiene(handle)) quitar(handle);
    else guardar(handle, btn.getAttribute('data-wishlist-talla') || '');
    pintarTodos();
  });

  // La talla elegida cambia mientras el corazón ya está puesto: se actualiza sin quitar el deseo.
  //
  // ⚠️ SE GUARDA EN SILENCIO, SIN `escribir()`. Cambiar la talla no cambia QUÉ piezas hay en la
  // lista, y el aviso de `escribir` repinta el panel entero: desde que las tallas no vienen
  // preelegidas (Daniel, 5-oct-2026), ese repintado borraba la talla que el socio ACABABA de tocar
  // en la tarjeta y el botón volvía a "Choose size" solo.
  document.addEventListener('casdeia:wishlist:talla', function (ev) {
    var d = ev.detail || {};
    if (!d.handle || !tiene(d.handle)) return;
    var lista = leer().map(function (i) { return i.h === d.handle ? { h: i.h, v: String(d.variantId || '') } : i; });
    try { localStorage.setItem(CLAVE, JSON.stringify(lista.slice(0, 200))); } catch (e) { /* da igual */ }
    pedir('members-wishlist-guardar', { producto: d.handle, talla: String(d.variantId || '') });
  });

  document.addEventListener('casdeia:wishlist', pintarTodos);

  // ── la fusión ───────────────────────────────────────────────────────────────────────────────
  // UNA VEZ POR VISITA, no en cada página. Es la única llamada que hace un socio solo por navegar, y
  // el servidor limita las peticiones por acción: repetirla en cada pantalla se comería el cupo de
  // quien mira muchos productos seguidos.
  function fundir() {
    if (!haySocio) return;
    try {
      if (sessionStorage.getItem(CLAVE + ':fundido') === cfg.cliente) return;
      sessionStorage.setItem(CLAVE + ':fundido', cfg.cliente);
    } catch (e) { /* sin sessionStorage se funde en cada página; feo, pero correcto */ }

    pedir('members-wishlist-fundir', { locales: leer() }).then(function (r) {
      // Solo se pisa la lista local si el servidor ha contestado que sí. Ante cualquier otra cosa
      // (caído, sin permiso, respuesta rara) se deja lo que el navegador ya tenía.
      if (!r || !r.ok || !Array.isArray(r.items)) return;
      escribir(r.items);
      pintarTodos();
    });
  }

  window.CasdeiaWishlist = { leer: leer, tiene: tiene, guardar: guardar, quitar: quitar, pintar: pintarTodos };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { pintarTodos(); fundir(); });
  } else { pintarTodos(); fundir(); }
})();

// ── EL BLOQUE DE LA LISTA DENTRO DEL PANEL ────────────────────────────────────────────────────
// Solo se activa si la pantalla lo pide (`[data-wishlist-lista]`), o sea únicamente en el panel del
// socio. En una ficha de producto este trozo no hace absolutamente nada.
(function () {
  var caja = document.querySelector('[data-wishlist-caja]');
  var lista = document.querySelector('[data-wishlist-lista]');
  if (!caja || !lista) return;

  // Lo que el escaparate ya nos ha contado de cada pieza, para no volver a pedirlo al repintar.
  var fichas = {};

  function dinero(centimos, moneda) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang === 'es' ? 'es-ES' : 'en-GB',
        { style: 'currency', currency: moneda || 'EUR' }).format(centimos / 100);
    } catch (e) { return (centimos / 100).toFixed(2) + ' €'; }
  }

  /**
   * Los datos de una pieza, del propio escaparate.
   *
   * ⚠️ UN 404 SÍ BORRA EL DESEO; UN FALLO DE RED NO. Si la pieza ya no existe en la tienda, dejarla
   * en la lista es enseñar para siempre un hueco que nunca se va a rellenar. Pero un servidor que no
   * contesta no es una pieza borrada, y confundir las dos cosas le vaciaría la lista a alguien por
   * haber abierto la página con mala cobertura.
   */
  function ficha(handle) {
    if (fichas[handle]) return Promise.resolve(fichas[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        if (r.status === 404) return 'no-existe';
        if (!r.ok) throw new Error('escaparate');
        return r.json();
      })
      .then(function (p) { fichas[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function tarjeta(p, handle) {
    var art = document.createElement('div');
    art.className = 'members__deseo';

    var a = document.createElement('a');
    a.className = 'members__deseo-enlace';
    a.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + handle;

    var img = document.createElement('span');
    img.className = 'members__deseo-foto';
    if (p.featured_image) {
      var i = document.createElement('img');
      // El escaparate acepta el tamaño en la propia dirección: se pide pequeña, no la original.
      i.src = String(p.featured_image).replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2');
      i.alt = '';
      i.loading = 'lazy';
      img.appendChild(i);
    }
    a.appendChild(img);

    var t = document.createElement('span');
    t.className = 'members__deseo-nombre';
    t.textContent = p.title || handle;
    a.appendChild(t);

    var pr = document.createElement('span');
    pr.className = 'members__deseo-precio';
    pr.textContent = p.available ? dinero(p.price, window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      : (lista.getAttribute('data-txt-agotado') || '');
    if (!p.available) pr.classList.add('esta-agotado');
    a.appendChild(pr);

    art.appendChild(a);

    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'members__deseo-quitar';
    x.setAttribute('data-wishlist-quitar', handle);
    x.setAttribute('aria-label', lista.getAttribute('data-txt-quitar') || 'Remove');
    x.textContent = '×';
    art.appendChild(x);

    art.appendChild(botonCarrito(p, handle));
    return art;
  }

  /**
   * EL BOTÓN DE AÑADIR AL CARRITO (Daniel, 23-ago-2026: "y un botón de añadir al carrito").
   *
   * ⚠️ TRES SITUACIONES, Y LA DEL MEDIO ES LA IMPORTANTE:
   *   · AGOTADO   → botón apagado. Se enseña igualmente: que se vea POR QUÉ no se puede.
   *   · SIN TALLA → la guardó sin elegir talla, o la pieza tiene varias. Aquí NO se mete una al
   *     azar: una talla elegida por el sistema es una devolución garantizada, y encima el envío de
   *     vuelta lo paga la casa. Se le manda a la ficha a elegir.
   *   · CON TALLA → esa talla concreta, la que eligió al guardarla, y solo si sigue habiendo DE ELLA
   *     (que no es lo mismo que "la pieza está disponible": puede quedar la L y estar agotada la S).
   */
  /**
   * Las tallas dentro de la tarjeta. Devuelve un trozo con el aviso, los botones y el de añadir.
   *
   * ⚠️ LAS AGOTADAS SE ENSEÑAN, TACHADAS Y APAGADAS. Esconderlas haría creer que esa talla no existe
   * y que la pieza no le sirve; tachada dice la verdad: existe y ahora no la hay.
   */
  function sinTalla(p, handle, botonAnadir, txt) {
    var trozo = document.createDocumentFragment();
    var variantes = (p.variants || []);

    var aviso = document.createElement('span');
    aviso.className = 'members__deseo-pide';
    aviso.textContent = txt('elegir', 'Choose size');
    trozo.appendChild(aviso);

    var caja = document.createElement('div');
    caja.className = 'members__deseo-tallas';
    variantes.forEach(function (v) {
      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'members__deseo-talla';
      // El título de la variante es lo que el cliente reconoce ("14", "S", "42"), no su id.
      t.textContent = v.title || v.option1 || '';
      if (!v.available) {
        t.disabled = true;
        t.title = txt('agotado', 'Sold out');
      } else {
        t.setAttribute('data-elegir-talla', String(v.id));
        t.setAttribute('data-handle', handle);
      }
      caja.appendChild(t);
    });
    trozo.appendChild(caja);

    botonAnadir.textContent = txt('elegir', 'Choose size');
    botonAnadir.disabled = true;
    trozo.appendChild(botonAnadir);
    return trozo;
  }

  function botonCarrito(p, handle) {
    var txt = function (k, x) { return lista.getAttribute('data-txt-' + k) || x; };
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'members__deseo-carrito';

    if (!p.available) {
      b.textContent = txt('agotado', 'Sold out');
      b.disabled = true;
      return b;
    }

    // ⚠️ LA TALLA SE PIDE AQUÍ, NO EN LA FICHA (Daniel, 25-ago-2026: "si tengo algo en la wishlist
    // que tiene tallas, me tiene que pedir la talla para añadirlo al carrito").
    //
    // Antes este botón te sacaba de la lista y te mandaba a la ficha del producto. Con cinco piezas
    // guardadas eso son cinco viajes de ida y vuelta para meterlas en el carrito, y en cada uno
    // pierdes la lista de vista. Ahora las tallas salen en la propia tarjeta.
    //
    // ⚠️ Y CON VARIAS TALLAS NUNCA HAY NADA PREELEGIDO (Daniel, 5-oct-2026: "debería poner Choose
    // size igual que en la ropa; aplica a todos los productos que tengan talla"). Ni siquiera la
    // talla guardada con el corazón: en joyería esa suele ser la que la ficha traía puesta de
    // serie, no una elección (cazado con el Deep Blue Bracelet, que entraba al carrito en la talla
    // más pequeña). El botón nace APAGADO en "Choose size" y lo enciende `elegirTalla` al pinchar
    // una talla: así nunca entra en el carrito una talla que nadie ha tocado, que es la regla que
    // no se toca (una talla puesta por el sistema es una devolución casi segura, y el envío de
    // vuelta lo paga la casa).
    var variantes = p.variants || [];
    if (variantes.length > 1) {
      return sinTalla(p, handle, b, txt);
    }

    // Una pieza de una sola variante no necesita que nadie elija nada.
    var unica = variantes[0];
    if (!unica || !unica.available) {
      b.textContent = txt('agotado', 'Sold out');
      b.disabled = true;
      return b;
    }
    b.textContent = txt('anadir', 'Add to cart');
    b.setAttribute('data-anadir-carrito', String(unica.id));
    return b;
  }

  function pintar() {
    var guardados = window.CasdeiaWishlist.leer();
    if (!guardados.length) {
      caja.classList.add('members--oculto');
      lista.textContent = '';
      vacio(true);
      return;
    }
    caja.classList.remove('members--oculto');
    vacio(false);

    Promise.all(guardados.map(function (i) { return ficha(i.h); })).then(function (ps) {
      // ⚠️ LAS PIEZAS BORRADAS SE QUITAN AL FINAL, NO SOBRE LA MARCHA. Quitar un deseo dispara el
      // aviso de cambio, que vuelve a llamar aquí: hacerlo dentro del bucle arrancaba un segundo
      // pintado a media lista y las piezas salían duplicadas.
      var muertas = [];
      ps.forEach(function (p, n) { if (p === 'no-existe') muertas.push(guardados[n].h); });
      if (muertas.length) {
        muertas.forEach(function (h) { window.CasdeiaWishlist.quitar(h); });
        return;                                           // el aviso de quitar ya repinta
      }

      lista.textContent = '';
      var vivos = 0;
      ps.forEach(function (p, n) {
        if (!p) return;                                   // fallo de red: se salta, NO se borra
        lista.appendChild(tarjeta(p, guardados[n].h));
        vivos++;
      });
      if (!vivos) caja.classList.add('members--oculto');
      // La cifra suelta ("1") en una esquina no se entiende. La frase entera viene de Liquid, que es
      // quien sabe el idioma; aquí solo se rellena la N.
      var cuenta = document.querySelector('[data-wishlist-cuenta]');
      if (cuenta) {
        cuenta.textContent = vivos === 1
          ? (cuenta.getAttribute('data-una') || '1')
          : (cuenta.getAttribute('data-varias') || 'N').replace('N', String(vivos));
      }
    });
  }

  /**
   * El hueco de "no has guardado nada". Solo existe en la página propia de la lista; dentro del
   * panel del socio no hay tal caja y esto no hace nada.
   *
   * ⚠️ NO PUEDE SALIR MIENTRAS TODAVÍA SE ESTÁ LEYENDO. Se llama desde `pintar()`, que ya ha leído
   * lo guardado: decir "no tienes nada" antes de mirar sería mentirle a alguien que sí tiene lista.
   */
  function vacio(mostrar) {
    var v = document.querySelector('[data-wishlist-vacio]');
    if (!v) return;
    v.classList.toggle('members--oculto', !mostrar);
  }

  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-wishlist-quitar]');
    if (!b) return;
    ev.preventDefault();
    window.CasdeiaWishlist.quitar(b.getAttribute('data-wishlist-quitar'));
  });

  // Sin talla elegida: a la ficha, que es donde se elige. No se añade nada a ciegas.
    // ── ELEGIR LA TALLA SIN SALIR DE LA LISTA ────────────────────────────────────────────────────
  //
  // Por delegación, como el resto: la lista se repinta entera cada vez que cambia algo, y un
  // listener pegado a cada botón moriría en el primer repintado.
  //
  // Hace TRES cosas, y las tres importan:
  //   1. marca la talla elegida (que se vea cuál has tocado),
  //   2. la GUARDA en el deseo, para que mañana la lista ya la recuerde y no vuelva a preguntar,
  //   3. enciende el botón de añadir con esa talla concreta.
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest && ev.target.closest('[data-elegir-talla]');
    if (!t || t.disabled) return;
    var tarjeta = t.closest('.members__deseo');
    if (!tarjeta) return;

    var caja = t.parentElement;
    [].forEach.call(caja.children, function (x) { x.classList.remove('esta-elegida'); });
    t.classList.add('esta-elegida');

    // Se recuerda para la próxima vez. Se usa el mismo camino que la ficha de producto, así que el
    // servidor se entera igual y la talla viaja con el socio a cualquier navegador.
    var handle = t.getAttribute('data-handle');
    if (handle && window.CasdeiaWishlist) {
      document.dispatchEvent(new CustomEvent('casdeia:wishlist:talla', {
        detail: { handle: handle, variantId: t.getAttribute('data-elegir-talla') },
      }));
    }

    var b = tarjeta.querySelector('.members__deseo-carrito');
    if (!b) return;
    var txt = function (k, x) { return lista.getAttribute('data-txt-' + k) || x; };
    b.disabled = false;
    b.setAttribute('data-anadir-carrito', t.getAttribute('data-elegir-talla'));
    // El botón DICE qué talla va a meter: es la última pantalla antes de añadir y no puede haber
    // duda de cuál se lleva.
    b.textContent = txt('anadir-talla', 'Add · Size N').replace('N', t.textContent);
  });

document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-ir-a-ficha]');
    if (!b) return;
    ev.preventDefault();
    location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + encodeURIComponent(b.getAttribute('data-ir-a-ficha'));
  });

  /**
   * AÑADIR AL CARRITO.
   *
   * ⚠️ EL BOTÓN SE APAGA MIENTRAS TANTO. Sin eso, dos toques seguidos en un móvil (que es donde se
   * usa esto) meten la pieza dos veces, y el cliente lo descubre en la caja.
   *
   * ⚠️ Y SI FALLA, SE DICE. "Añadir y confiar" deja al cliente creyendo que la pieza está en el
   * carrito cuando no lo está.
   */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-anadir-carrito]');
    if (!b || b.disabled) return;
    ev.preventDefault();
    var txt = function (k, x) { return lista.getAttribute('data-txt-' + k) || x; };
    var original = b.textContent;
    b.disabled = true;
    b.textContent = txt('anadiendo', 'Adding…');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-anadir-carrito')), quantity: 1 }] }),
    })
      .then(function (r) { if (!r.ok) throw new Error('carrito'); return r.json(); })
      .then(function () {
        b.textContent = txt('anadido', 'In your cart');
        b.classList.add('esta-anadido');
        // ⚠️ ESTOS TRES NOMBRES SON LOS DEL TEMA Y NO SE PUEDEN INVENTAR. Aquí había
        // `cart:refresh` y `cart:build`, que NO EXISTEN en Symmetry: la pieza entraba en el carrito
        // (el /cart/add.js devolvía 200) pero ni el contador de la cabecera ni el cajón se enteraban,
        // así que el botón decía "en tu carrito" y al abrirlo estaba vacío. Parecía que no se había
        // añadido nada. (Daniel, 23-ago-2026.)
        //
        // Los buenos están documentados en assets/custom.js:
        //   on:cart:change            → lo escuchan la cabecera (contador) y el formulario del carrito
        //   dispatch:cart-drawer:*    → refrescar y abrir el cajón
        // Y se abre el cajón a propósito: ver la pieza entrar es la única confirmación que se cree.
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
        setTimeout(function () {
          b.disabled = false; b.textContent = original; b.classList.remove('esta-anadido');
        }, 2600);
      })
      .catch(function () {
        b.textContent = txt('fallo', 'Could not add');
        b.classList.add('esta-mal');
        setTimeout(function () {
          b.disabled = false; b.textContent = original; b.classList.remove('esta-mal');
        }, 2600);
      });
  });

  // Se repinta con cada cambio, venga de esta pantalla o de la fusión con la cuenta.
  document.addEventListener('casdeia:wishlist', pintar);
  pintar();
})();
